import { Component, OnInit } from '@angular/core';
import { DictionaryStore } from 'src/app/stores/dictionary.store';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-dictionary-detail',
  templateUrl: './dictionary-detail.component.html',
  styleUrls: ['./dictionary-detail.component.scss']
})
export class DictionaryDetailComponent implements OnInit {
  data:any
  constructor(
    public store: DictionaryStore,
    private router:ActivatedRoute,
    private location:Location
  ) { }

  ngOnInit() {
    this.router.params.subscribe(param=>{
      this.store.fetchSelectedData('dictionary', param.id, data=>{
        this.data = data
      })
    })
  }

  goBack(){
    this.location.back()
  }
}
